export const storeRecentProducts = (id: string) => {
  // Set recent products
  const recentIdsString = localStorage.getItem("recents");
  if (!recentIdsString) localStorage.setItem("recents", `${id}`);
  else {
    const recentProductIds = recentIdsString.split(",");
    const index = recentProductIds.indexOf(id);
    if (index > -1) {
      recentProductIds.splice(index, 1);
    }
    recentProductIds.unshift(id);
    if (recentProductIds.length > 12) {
      recentProductIds.pop();
    }
    localStorage.setItem("recents", recentProductIds.toString());
  }
}